import React, { useState } from "react";
import Logo from "@/components/Logo";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const APP_URL = "https://app.fittrackcoach.in";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    setMsg("");
    try {
      const res = await axios.post(`${API}/subscribe`, { email: email.trim() });
      if (res.data && res.data.ok) {
        setStatus("success");
        setMsg("You're on the list. We'll be in touch.");
        setEmail("");
      } else {
        setStatus("error");
        setMsg("Something went wrong. Please try again.");
      }
    } catch (err) {
      setStatus("error");
      setMsg(err?.response?.data?.detail || "Please enter a valid email.");
    }
  };

  return (
    <footer className="pt-16 pb-10 border-t border-white/5 bg-[#030611]" data-testid="footer">
      <div className="section-container">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <Logo height={72} />
            <p className="mt-5 text-sm text-white/55 max-w-sm leading-relaxed">
              The all-in-one platform for gym trainers & fitness coaches to manage clients, track progress, and grow their coaching business.
            </p>
            <form onSubmit={submit} className="mt-6 flex gap-2 max-w-sm" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (msg) setMsg("");
                  if (status !== "idle") setStatus("idle");
                }}
                placeholder="Your email for updates"
                className="flex-1 bg-white/5 border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-cyan-500/50"
                data-testid="newsletter-input"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="btn-primary-glow rounded-lg px-4 py-2.5 text-sm font-bold"
                data-testid="newsletter-submit"
              >
                {status === "loading" ? "…" : "Notify"}
              </button>
            </form>
            {msg && (
              <div className={`mt-2 text-xs ${status === "success" ? "text-cyan-300" : "text-red-400"}`} data-testid="newsletter-msg">{msg}</div>
            )}
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Product</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#features" className="hover:text-white">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-white">How it works</a></li>
              <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Company</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="mailto:support@fittrackcoach.in" className="hover:text-white">Contact</a></li>
              <li><a href="#" className="hover:text-white">About</a></li>
              <li><a href="#" className="hover:text-white">Blog</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Get started</div>
            <a
              href={APP_URL}
              className="btn-primary-glow rounded-xl px-5 py-3 text-sm font-bold inline-flex items-center gap-2"
              data-testid="footer-cta"
            >
              Start Free
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
              </svg>
            </a>
            <div className="mt-4 text-xs text-white/40">
              Questions? <a href="mailto:support@fittrackcoach.in" className="text-cyan-300 hover:underline">support@fittrackcoach.in</a>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} FitTrackCoach. All rights reserved.
          </div>
          <div className="flex items-center gap-5 text-xs text-white/40">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Refund policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
